import { render, staticRenderFns } from "./Infoform.vue?vue&type=template&id=2879f012"
import script from "./Infoform.vue?vue&type=script&lang=js"
export * from "./Infoform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports